import hash from './hash'
import json from './json'
import url from './url'
import encoding from './encoding'
import number from './number'

export default { ...hash, ...json, ...url, ...encoding, ...number }
